import * as React from "react";
import classnames from "classnames";
import { Expander } from "@grandvisionhq/common";
import { pushImageGalleryOpenEvent } from "../../../Analytics/events/modules/Analytics/events/ImageGalleryEvents.js";
/* empty css                         */
import { useProductImageGallerySlots } from "../../slots/modules/ProductImageGallery/slots/context.js";
import { ProductImage } from "../../components/ProductImage/modules/ProductImageGallery/components/ProductImage/ProductImage.js";
import { ZoomModal } from "../../components/ZoomModal/modules/ProductImageGallery/components/ZoomModal/ZoomModal.js";
const desktopImageSizes = {
  M: 768,
  L: 1024,
  XL: 1440,
  MAX: 1440
};
const ProductImageGallery = ({
  initialImages,
  expandableImages,
  showMoreLabel,
  showLessLabel,
  handleGalleryExpansion,
  handleImageInteraction,
  isImageVisible,
  isExpanded,
  zoomModalOpenIndex,
  buttonClickedForZoomRef,
  sku
}) => {
  const { Slots } = useProductImageGallerySlots();
  if (!initialImages || initialImages.length === 0) {
    return null;
  }
  const handleImageClick = (index, altText) => {
    handleImageInteraction(index);
    if (sku && index === 0) {
      pushImageGalleryOpenEvent(altText, index, sku);
    }
  };
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      "data-t": "product-image-gallery",
      className: classnames("product-image-gallery", {
        "product-image-gallery--full-width": initialImages.length <= 2
      })
    },
    Slots.TopLeft && /* @__PURE__ */ React.createElement(Slots.TopLeft, { className: "product-image-gallery__top-left" }),
    Slots.TopRight && /* @__PURE__ */ React.createElement(Slots.TopRight, { className: "product-image-gallery__top-right" }),
    /* @__PURE__ */ React.createElement("div", { className: "product-image-gallery__images" }, initialImages.map((image, index) => /* @__PURE__ */ React.createElement(
      "div",
      {
        key: image.label,
        className: classnames("product-image-gallery__image", {
          "product-image-gallery__image--highlighted": image.highlighted
        })
      },
      /* @__PURE__ */ React.createElement(
        ProductImage,
        {
          ref: index === zoomModalOpenIndex ? buttonClickedForZoomRef : null,
          onClick: () => handleImageClick(index, image.altText),
          altText: image.altText,
          imageUrl: image.url,
          zoom: image.zoom,
          imageSizes: desktopImageSizes,
          sku
        }
      )
    ))),
    !!expandableImages.length && /* @__PURE__ */ React.createElement(
      Expander,
      {
        className: "product-image-gallery__expanded-images",
        showMoreLabel,
        showLessLabel,
        id: "gallery-expander",
        onExpandCallback: handleGalleryExpansion
      },
      expandableImages.map((image, index) => /* @__PURE__ */ React.createElement(
        "div",
        {
          key: image.label,
          className: classnames("product-image-gallery__expanded-image", {
            "product-image-gallery__image--highlighted": image.highlighted
          })
        },
        /* @__PURE__ */ React.createElement(
          ProductImage,
          {
            ref: index + initialImages.length === zoomModalOpenIndex ? buttonClickedForZoomRef : null,
            onClick: () => handleImageClick(index + initialImages.length, image.altText),
            altText: image.altText,
            imageUrl: image.url,
            showImage: isImageVisible,
            disableButton: !isExpanded,
            imageSizes: desktopImageSizes,
            zoom: image.zoom,
            sku
          }
        )
      ))
    ),
    /* @__PURE__ */ React.createElement(
      ZoomModal,
      {
        isOpen: zoomModalOpenIndex !== null,
        openingIndex: zoomModalOpenIndex,
        onClose: () => handleImageInteraction(null),
        images: [...initialImages, ...expandableImages]
      }
    )
  );
};
export {
  ProductImageGallery
};
//# sourceMappingURL=ProductImageGallery.js.map
